<template>
  <div class="chart-container">
    <h5 v-if="title" class="chart-title">{{ title }}</h5>
    <div v-if="loading" class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
    <div v-else-if="!hasData" class="d-flex justify-content-center align-items-center h-100">
      <div class="text-muted">Aucune donnée disponible</div>
    </div>
    <Pie
      v-else
      :chart-data="safeChartData"
      :chart-options="chartOptions"
    />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'PieChart',
  components: { Pie },
  props: {
    title: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] })
    },
    loading: {
      type: Boolean,
      default: false
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'right'
          }
        }
      })
    }
  },
  computed: {
    hasData() {
      return this.chartData && 
             this.chartData.datasets && 
             this.chartData.datasets.length > 0 && 
             this.chartData.labels && 
             this.chartData.labels.length > 0;
    },
    safeChartData() {
      // Ensure we always return a valid chart data structure
      if (!this.hasData) {
        return { labels: [], datasets: [] };
      }
      return this.chartData;
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px;
  width: 100%;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.chart-title {
  font-size: 1.1rem;
  margin-bottom: 15px;
}
</style>
